
const base_url = 'http://sena-solar.wisdomcloud.net/v1/api/get';

export const URL_GET_PROJECT = base_url+'/project'; // 'http://www.mocky.io/v2/5a41d825320000f839ac34ee';
export const URL_GET_PLAN = base_url+'/plan';
export const URL_GET_SUMMARY = base_url+'/summary'; //'http://www.mocky.io/v2/5a41f1fc3000004b03709c6c';



// WEBPACK FOOTER //
// ./src/constants/index.js